import React, { useEffect } from 'react'
import { SiteHeader } from '../../components/site-header'
import { KickstarterHero } from '../../components/ai-kickstarter/hero-section'
import { ProcessSection } from '../../components/ai-kickstarter/process-section'
import { BenefitsSection } from '../../components/ai-kickstarter/benefits-section'
import { TestimonialsSection } from '../../components/shared/testimonials-section'
import { ContactCtaSection } from '../../components/shared/cta-section'
import { METADATA } from '../../components/meta/metadata'

export default function AiKickstarterPage() {
  // Set metadata for the page
  useEffect(() => {
    document.title = METADATA.aiKickstarter.title;

    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', METADATA.aiKickstarter.description);
  }, []);

  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <KickstarterHero />
        <ProcessSection />
        <BenefitsSection />
        <TestimonialsSection className="bg-primary/5" />
        <ContactCtaSection className="plain" spacingClass="py-20 pb-32" />
      </main>
    </div>
  )
}
